import { api } from '@/api/client'

export type TenantBrandingPayload = {
  logo_url: string | null
  logo_url_dark: string | null
  logo_mobile_url: string | null
  logo_mobile_url_dark: string | null
  favicon_url: string | null
  website_name: string | null
  tenant_name: string | null
}

export const TENANT_BRANDING_QUERY_KEY = ['tenant-branding'] as const

export async function fetchTenantBranding(): Promise<TenantBrandingPayload> {
  const { data } = await api.get<{ success: boolean; data: TenantBrandingPayload }>('/branding')
  return data.data
}
